<div class="related-benefits">
    <div class="related-benefits__inner">
        <h2 class="related-benefits__header" *ngIf="block.data.header">{{block.data.header}}</h2>

        <div class="related-benefits__items">
            <div *ngFor="let content of block.content; trackBy: trackByFn;" class="related-benefits__item">
                <a *ngIf="content.data.pageLink" class="related-benefits__item-wrapper"
                   href="javascript:void(0)"
                   (click)="navigateToPage('/' + content.data.pageLink)">
                    <div *ngIf="content.data.image" class="related-benefits__item-image" [ngStyle]="{backgroundImage: content.data.image ? 'url(' + content.data.image + ')' : null}"></div>
                    <h3 *ngIf="content.data.header" class="related-benefits__item-header">{{content.data.header}}</h3>
                    <div *ngIf="content.data.category" class="related-benefits__item-category category-tag" [ngClass]="content.data.category.value">{{content.data.category.text}}</div>
                    <p *ngIf="content.data.text" class="related-benefits__item-text">{{content.data.text}}</p>
                </a>
                <div *ngIf="!content.data.pageLink" class="related-benefits__item-wrapper">
                    <div *ngIf="content.data.image" class="related-benefits__item-image" [ngStyle]="{backgroundImage: content.data.image ? 'url(' + content.data.image + ')' : null}"></div>
                    <h3 *ngIf="content.data.header" class="related-benefits__item-header">{{content.data.header}}</h3>
                    <div *ngIf="content.data.category" class="related-benefits__item-category category-tag" [ngClass]="content.data.category.value">{{content.data.category.text}}</div>
                    <p *ngIf="content.data.text" class="related-benefits__item-text">{{content.data.text}}</p>
                </div>
            </div>
        </div>

        <div *ngIf="block.data.buttonLink && block.data.buttonText" class="related-benefits__button-wrapper">
            <a [href]="block.data.buttonLink" class="related-benefits__button btn btn-primary">{{block.data.buttonText}}</a>
        </div>
    </div>
</div>
